
   function formatPrice(priceInCents) {
    // Get Shopify's locale and currency dynamically
    const locale = Shopify.locale || '{{ request.locale.iso_code }}' || 'en-US';
    const currency = Shopify.currency?.active || '{{ shop.currency }}' || 'USD';

    // Convert cents to major currency unit
    const amount = priceInCents / 100;

    // Format using locale & currency
    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

    // Force currency symbol to appear in front
    // Extract symbol and numeric part using a regex
    const symbol = formatted.replace(/[\d\s.,-]+/g, '').trim(); // removes digits and separators
    const numeric = formatted.replace(/[^\d.,-]+/g, '').trim(); // keeps only numbers and separators
    const formattedAmount = `${symbol}${numeric}`; // symbol always in front

    return formattedAmount;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const includedSelect = document.getElementById('included-product-select');
    const includedItemsContainer = document.getElementById('included-items-container');
    const priceEl = document.querySelector('.included-price');

    // Get all variant option names (Power, Color, Package)
    const variantSelectsOptionNames = Array.from(
      document.querySelectorAll('variant-selects select[name^="options"]')
    ).map((sel) => sel.name.replace('options[', '').replace(']', ''));

    /**
     * Show included items and update price for selected variant
     */
    function showVariant(variantId) {
      // Hide all variant items
      includedItemsContainer.querySelectorAll('.variant-items').forEach((el) => (el.style.display = 'none'));

      // Show selected variant items
      const activeItems = includedItemsContainer.querySelector('#variant-items-' + variantId);
      if (activeItems) activeItems.style.display = 'block';

      // Update price using the **formatted price** stored in data-formatted-price
      const selectedOption = includedSelect.querySelector(`option[value="${variantId}"]`);
      if (selectedOption && priceEl) {
        // *** THE KEY UPDATE IS HERE ***
        priceEl.innerHTML = selectedOption.dataset.formattedPrice;
      }
    }

    function updateIncludedProduct(selectedOptions) {
      // Get all variants JSON
      const variantsJSON = document.querySelector('variant-selects script[type="application/json"]');
      const allVariants = variantsJSON ? JSON.parse(variantsJSON.textContent) : [];

      // Filter variants that match all options except Package
      const matchingVariants = allVariants.filter((variant) =>
        variant.options.every((opt, idx) => {
          const optionName = variantSelectsOptionNames[idx];
          if (optionName.toLowerCase().includes('package')) return true;
          return selectedOptions[idx] === opt;
        })
      );

      // Populate dropdown
      includedSelect.innerHTML = '';
      matchingVariants.forEach((variant) => {
        const packageIndex = variant.options.findIndex((_, i) =>
          variantSelectsOptionNames[i].toLowerCase().includes('package')
        );
        const optionEl = document.createElement('option');
        optionEl.value = variant.id;
        optionEl.textContent = variant.options[packageIndex];

        // Store the raw price (in cents) and the formatted price
        optionEl.dataset.price = variant.price;
        // *** THE KEY UPDATE IS HERE ***
        optionEl.dataset.formattedPrice = formatPrice(variant.price);

        includedSelect.appendChild(optionEl);
      });

      // Show first variant by default
      if (includedSelect.options.length > 0) {
        includedSelect.value = includedSelect.options[0].value;
        showVariant(includedSelect.value);
      }
    }

    // Listen to Included Product dropdown change
    includedSelect.addEventListener('change', function () {
      showVariant(this.value);
    });

    // ... (rest of the Custom Variant Picker listener code remains the same)

    // Listen to Custom Variant Picker clicks
    document.querySelectorAll('.custom-variant-card').forEach((card) => {
      card.addEventListener('click', () => {
        const optionPos = parseInt(card.dataset.optionPosition) - 1;
        const variantSelects = card.closest('variant-selects').querySelectorAll('select[name^="options"]');

        // Update hidden selects
        variantSelects[optionPos].value = card.dataset.value;
        variantSelects[optionPos].dispatchEvent(new Event('change', { bubbles: true }));

        // Build selected options array
        const selectedOptions = Array.from(variantSelects).map((sel) => sel.value);

        // Update Included Product dropdown
        updateIncludedProduct(selectedOptions);
      });
    });

    // Initialize on page load
    const initialOptions = Array.from(document.querySelectorAll('variant-selects select[name^="options"]')).map(
      (sel) => sel.value
    );
    updateIncludedProduct(initialOptions);

    // Toggle dropdown arrow
    includedSelect.addEventListener('click', () => {
      includedSelect.classList.toggle('selectBg');
    });
  });
